import React, {useState, useEffect} from 'react';
import {
    Container,
    Button,
    Menu,
    Grid,
    GridColumn,
    Image,
    Header, Icon,
} from 'semantic-ui-react'
import {useSelector, useDispatch} from "react-redux";

import withRouter from "../common/withRouter";

import {
    inquiryGet,
} from '../slices/register'

import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';

import "cleave.js/dist/addons/cleave-phone.us"

const ThankYou = (props) => {
    const dispatch = useDispatch();
    const {data} = useSelector((state) => ({
        data: state.register.data,
    }));

    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(props.router.location.search);
        const id = params.get("id")
        if (id) {
            dispatch(inquiryGet(window.CONFIG.orgId, id))
        } else {
            props.router.navigate('/getstarted')
        }
    }, [dispatch, props])
    const isMobile = width <= 768;

    return (
        <React.Fragment>
            {/*<Container style={{marginTop: '3em', alignContent: "center"}}>*/}
            <Grid doubling columns={"equal"}
                  style={{
                      padding: 20,
                      alignContent: "center",
                      paddingLeft: isMobile ? 20 : 100,
                      paddingRight: isMobile ? 20 : 100
                  }}>

                <GridColumn style={{
                    padding: 0,
                    paddingTop: 15,
                    textAlign: isMobile ? "center" : "initial",
                    display: "flex",
                    alignItems: "center"
                }}>
                    <Image style={{height: 50}} src={process.env.PUBLIC_URL + '/amston_commercial_logo_3Uv_icon.ico'}/>
                    <Header as={'h4'} style={{cursor: "pointer", margin: "0px 15px"}}>
                        Confirmation
                    </Header>
                </GridColumn>
            </Grid>
            <Menu inverted
                  style={{
                      backgroundColor: "#990001",
                      padding: 30,
                      marginBottom: 0,
                      borderRadius: 0
                  }}>
                <Container style={{
                    paddingTop: "3em",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "calc(100vh - 151px)"
                }}>
                    <Header as={"H3"} textAlign='center' style={{color: "white"}}>
                        {data?.success?.message}
                    </Header>
                    <div style={{textAlign: 'center', paddingTop: "3em"}}>
                        <Button
                            className={'menu_button'}
                            aria-label={'submit'}
                            onClick={() => {
                                props.router.navigate('/')
                            }}
                            style={{paddingLeft: 40, paddingRight: 40}}
                        >
                            OK
                        </Button>
                    </div>
                </Container>
            </Menu>
            <footer>
                <Grid doubling columns={"equal"}
                      style={{
                          paddingLeft: isMobile ? 10 : 100,
                          paddingRight: isMobile ? 10 : 100,
                          alignContent: "center"
                      }}>

                    <GridColumn style={{
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Header as={'h4'} style={{cursor: "pointer"}}>
                            <Image style={{height: 150, width: "auto"}}
                                   src={process.env.PUBLIC_URL + '/Amston-Commercial-Logo_512_Black_and_white.png'}/>
                        </Header>
                    </GridColumn>
                    <GridColumn style={{
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "initial",
                        float: "right"
                    }}>
                        <div style={{float: "right"}}>
                            <p className={"contact"}><Icon name='phone' size='large'/> (860) 920-5377</p>
                            <p className={"contact"}><Icon name='map pin' size='large'/> Wallingford, CT</p>
                            <p className={"contact"}><Icon name='mail' size='large'/> info @ amstonstudentstorage .com
                            </p>
                        </div>
                    </GridColumn>
                </Grid>
                <p>
                    Amston Student Storage 2025
                </p>
            </footer>
        </React.Fragment>
    );
};

export default withRouter(ThankYou);
